(function ( $ ) {
    let current_textareas = [];
    $.fn.customTextarea = function(callback, args = {}) {
        let new_mce = 0;
        let new_code = 0;
        let current_codeareas = [];
        $(this).each(function() {
            var elm = $(this);
            if(elm.is(':visible')) {
                if (!elm.hasClass('code') && !elm.hasClass('ace_text-input')) {
                    let id = elm.attr('data-tinymce-id');
                    if(id === undefined) {
                        id = get_unique_id('data-tinymce-id');
                        elm.attr('data-tinymce-id', id);
                        new_mce++;
                    }

                    const selector = '[data-tinymce-id="'+id+'"]';
                    current_textareas.push(selector);
                } else {
                    if (elm.hasClass('ace_text-input')) {
                        elm.parents('pre.ace_editor').height(400);
                        return;
                    }

                    let ce_id = elm.attr('data-code-editor-id');
                    if(ce_id === undefined) {
                        ce_id = get_unique_id('data-code-editor-id');
                        elm.attr('data-code-editor-id', ce_id);

                        const style = elm.attr('style');
                        const div = $('<div />');
                        elm.after(div);

                        const id = get_unique_id();
                        div.attr('id', id);
                        div.attr('data-mode', elm.attr('data-mode'));

                        if (elm.is('[data-beautify]')) {
                            div.attr('data-beautify', elm.attr('data-beautify'));
                        }

                        div.html(elm.html());
                        div.css({
                            height: '400px'
                        });

                        if (style !== undefined) {
                            div.attr('style', style);
                        }

                        elm.hide();

                        new_code++;
                        current_codeareas.push(id);
                    } else {
                        current_codeareas.push(elm.next().attr('id'));
                    }
                }
            }
        });

        current_textareas = _.uniq(current_textareas.filter((selector) => $(selector).length > 0));
        current_codeareas = _.uniq(current_codeareas.filter((id) => $(`#${id}`).length > 0));


        if(new_mce > 0) {
            $('body').isLoading();

            tinyMCE.remove();
            tinymce.init({
                selector: current_textareas.join(', '),
                language: 'nl',
                menubar: false,
                statusbar: false,
                content_css : "/js/tinymce/plugins/specialloops/css/loops.css",
                extended_valid_elements : "special-loop[data-loop]",
                custom_elements: "special-loop[data-loop]",
                plugins: 'code link image specialloops',
                toolbar1: (args && Object.keys(args).includes('toolbar1')) ? args.toolbar1 : 'undo redo styleselect bold italic',
                toolbar2: (args && Object.keys(args).includes('toolbar2')) ? args.toolbar2 : 'link image code specialloops',
                toolbar3: (args && Object.keys(args).includes('toolbar3')) ? args.toolbar3 : 'alignleft aligncenter alignright bullist numlist outdent indent',
                force_br_newlines : false,
                force_p_newlines : false,
                forced_root_block : '',
                setup: function(editor) {
                    $('body').doneLoading();

                    const updateValue = function (e) {
                        $(editor.targetElm).val(editor.getContent());
                    };
                    editor.on('keyup', updateValue);
                    editor.on('change', updateValue);
                },
            });
        }
        if (new_code > 0) {
            current_codeareas.forEach(function(id) {
                let wait = false;
                try {
                    const test = ace.edit;
                } catch(e) {
                    const tag = document.createElement("script");
                    tag.src = "/js/ace/ace.js";
                    document.getElementsByTagName("head")[0].appendChild(tag);

                    wait = true;
                }


                const loadBeautify = function() {
                    if (window.beautify === undefined) {

                        const beautify = ace.require("ace/ext/beautify");
                        if (beautify === undefined) {
                            const beautifyTag = document.createElement("script");
                            beautifyTag.src = "/js/ace/ext-beautify.js";
                            document.getElementsByTagName("head")[0].appendChild(beautifyTag);
                        } else {
                            window.beautify = beautify;
                        }
                        return beautify;
                    } else {
                        return window.beautify;
                    }
                };

                let intVal = null;
                const fn = function() {
                    if (window.ace === undefined) {
                        return;
                    }
                    if (loadBeautify() === undefined) {
                        return;
                    }
                    if (intVal !== null) {
                        clearInterval(intVal);
                    }
                    const elm = $('#' + id);
                    const mode = elm.attr('data-mode');
                    const editor = ace.edit(id);
                    editor.setTheme("ace/theme/dracula");
                    editor.session.setMode("ace/mode/" + mode);

                    let afterRan = false;

                    editor.renderer.on('afterRender', function() {

                        if (!afterRan) {
                            $(editor.container).css('opacity', 1);
                            if (elm.is('[data-beautify]')) {
                                setTimeout(function() {
                                    elm.bind('beautify', function() {
                                        loadBeautify().beautify(editor.getSession());
                                    }).trigger('beautify');
                                }, 1000);
                            }
                            afterRan = true;
                        }
                    });

                    editor.getSession().on("change", function () {
                        $(editor.container).prev().val(editor.getSession().getValue());
                    });
                };


                if (!wait) {
                    fn();
                } else {
                    intVal = setInterval(fn,100);
                }
            });
        }

        return this;
    };

}( jQuery ));

jQuery(document).ready(function($) {
    $('textarea').customTextarea();
});
